export const containerStyles = 'overflow-y-auto scrollbar h-screen'
export const contentWrapperStyles =
   'w-[620px] mx-auto my-[48px] flex flex-col gap-4'
export const headerContainerStyles = 'flex flex-col gap-1'
export const titleStyles = 'text-xl-semibold'
export const descriptionStyles = 'text-md-medium'
